export default function generateGoogleMapsLink(address: string) {
  if (!address) {
    return "";
  }
  const encoded = encodeURIComponent(address);
  return `https://www.google.com/maps/search/?api=1&query=${encoded}`;
}
